// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useMaximumScreenBrightness = (_shouldApply: boolean = true) => {};

export default useMaximumScreenBrightness;
